import Restriction from "../restriction";
import meshRestrictionHelper from "../meshRestrictionHelper";

class RestrictVolume extends Restriction {
    constructor() {
        super({type: meshRestrictionHelper.RestrictedMeshTypeEnum.VOLUME});
    }

    isValid(volumeIDs = []) {
        if (volumeIDs.length === 0) return true;

        let invalidVolumeIDs = [];
        volumeIDs.forEach(volumeID => {
            if (!super.isValid(volumeID)) invalidVolumeIDs.push(volumeID);
        });

        if (invalidVolumeIDs.length > 0) {
            console.error('Restricted volume found: ' + invalidVolumeIDs);
        }

        return invalidVolumeIDs.length === 0;
    }

    getPopulatedDataByType(volumes = [], applyTo, mode = meshRestrictionHelper.RestrictionMode.ALLOW_ALL) {
        const data = [];
        if (applyTo !== this.type) {
            return data;
        }
        if (mode === meshRestrictionHelper.RestrictionMode.DENY_ALL) {
            const modelIds = modelManager.getAllModelsId();
            modelIds.forEach(modelId => {
                data.push(...modelManager.getBranchIds(modelId));
            });
        } else {
            data.push(...volumes.map(volume => volume.id));
        }
        return data;
    }
}

export default RestrictVolume;